/* eslint-disable */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Inventory, { msgs as inventoryMsgs } from "../Inventory/Inventory";
import { withState, compose, lifecycle, pure, mapProps } from "recompose";
import styles from "./GroupedInventoryList.scss";
import constants from "../../utils/constants";
import { Modal, BookableErrorMessage } from "~/components";
import classnames from "classnames";
import {
  defineMessages,
  injectIntl,
  FormattedMessage,
  FormattedDate,
  FormattedNumber,
} from "react-intl";
import { VistoIcon } from "../../theme/assets";
import { RateIcon } from "../../theme/assets";
import { Popup } from "@witbooking/react-components";

export const msgs = defineMessages({
  listofRates: {
    id: "titles.ListofRatesTitle",
    description: "Header title",
    defaultMessage: "List of Rates",
  },
  viewAvailability: {
    id: "groupedinventoryList.label.viewAvailability",
    description: "Shows Inventory availability",
    defaultMessage: "view availability",
  },
  perNight: {
    id: "groupedinventoryList.label.night",
    description: "Label that specify rate per night",
    defaultMessage: "night",
  },
  availability: {
    id: "groupedinventoryList.label.availability",
    description: "availability Text",
    defaultMessage: "View availability",
  },
  comparePrices: {
    id: "groupedinventoryList.compare.prices",
    description: "Option to compare inventory prices",
    defaultMessage: "compare prices",
  },
  lastAvailable: {
    id: "groupedinventoryList.label.lastAvailable",
    description: "Announcement of last available inventory",
    defaultMessage: "Last One!",
  },
  rooms: {
    id: "groupedinventoryList.label.numberOfRooms",
    description: "Label to announce the number of rooms",
    defaultMessage: "Room/s",
  },
  BOOK: {
    id: "groupedinventoryList.button.book",
    description: "Button to book a reservation",
    defaultMessage: "BOOK",
  },
  LOCK: {
    id: "groupedinventoryList.restriction.lock",
    description: "Locked Restriction message on inventory",
    defaultMessage: "Not available",
  },
  MIN_STAY: {
    id: "groupedinventoryList.restriction.minStay",
    description: "Min Stay Restriction message on inventory",
    defaultMessage: "Min. Stay:  {val} days",
  },
  MAX_STAY: {
    id: "groupedinventoryList.restriction.maxStay",
    description: "Max Stay Restriction message on inventory",
    defaultMessage: "Max. Stay:  {val} days",
  },
  CHECK_IN: {
    id: "groupedinventoryList.restriction.checkIn",
    description: "check-in check-out restriction message on inventory",
    defaultMessage: "Check-in on:  {val}",
  },
  CHECK_OUT: {
    id: "groupedinventoryList.restriction.checkOut",
    description: "check-in check-out restriction message on inventory",
    defaultMessage: "Check-out on:  {val}",
  },
  MAX_NOTICE: {
    id: "groupedinventoryList.restriction.maxNotice",
    description: "Max Notice Restriction message on inventory",
    defaultMessage: "Max. Advance:  {val} days",
  },
  MIN_NOTICE: {
    id: "groupedinventoryList.restriction.minNotice",
    description: "Min Notice Restriction message on inventory",
    defaultMessage: "Min. Advance:  {val} days",
  },
  MAX_NOTICE_HOURS: {
    id: "groupedinventoryList.restriction.minStayHours",
    description: "Max Notice Restriction message on inventory",
    defaultMessage: "Max. Advance:  {val} hours",
  },
  MIN_NOTICE_HOURS: {
    id: "groupedinventoryList.restriction.minNoticeHours",
    description: "Min Notice Restriction message on inventory",
    defaultMessage: "Min. Advance:  {val} hours",
  },
  UNAVAILABLE: {
    id: "groupedinventoryList.restriction.unavailable",
    description: "Unavailable message on inventory",
    defaultMessage: "SOLD OUT",
  },
  readConditions: {
    id: "groupedinventoryList.restriction.readConditions",
    description: "Read conditions label",
    defaultMessage: "read conditions",
  },
  night: {
    id: "groupedinventoryList.night",
    description: "Night",
    defaultMessage: "night",
  },
});
function getOptionText(inventory, criteria, separator, asArray) {
  const textArr = criteria.map(bucket => {
    switch (bucket) {
      case constants.BUCKETS.CONDITION:
        return inventory.get("condition").get("name");
      case constants.BUCKETS.MEALPLAN:
        return inventory.get("mealplan").get("name");
      case constants.BUCKETS.CONFIGURATION:
        return inventory.get("configuration").get("name");
      case constants.BUCKETS.ACCOMMODATION:
        return "";
      default:
        return "";
    }
  });
  return asArray ? textArr : textArr.join(separator ? ` ${separator} ` : " ");
}
function handleOptionSelect(
  inventoryGroups,
  selectedInventoryGroup,
  ticker,
  setInventoryGroups,
  closeModal
) {
  setInventoryGroups(() => inventoryGroups.setIn([selectedInventoryGroup, "selected"], ticker));
  closeModal();
}
function getStatusDetails(
  status,
  type,
  value,
  labelClassName,
  failedValueClassName,
  successValueClassName
) {
  if (!status) {
    return null;
  }
  return {
    status: status,
    valueType: type,
    value: value,
    labelClassName: labelClassName,
    valueClassName:
      status === constants.BOOKABLE_STATUS.AVAILABLE ? successValueClassName : failedValueClassName,
  };
}
const PriceOption = ({
  ticker,
  text,
  priceDifference,
  rate,
  statusCode,
  onOptionSelect,
  statusFilterType,
  statusValue,
  selected,
  selectedIsDisabled,
  currency,
  dailyRate,
}) => (
  <div
    onClick={onOptionSelect}
    className={classnames(
      "wbkv9-PriceOption",
      selected && "wbkv9-PriceOption-selected",
      styles.priceOption,
      selected && styles.selected,
      statusCode !== "AVAILABLE" && styles.disabled
    )}
    style={{ hotelcolor: "blue" }}>
    {selected && (
      <div className={styles.selectedIcon}>
        <VistoIcon />
      </div>
    )}
    <div className={classnames("wbkv9-PriceOption-text", styles.text)}>
      <div className={styles.firstBucket}>{text[0]}</div>
      {text[1] && <div className={styles.secondBucket}>{text[1]}</div>}
    </div>
    <div className={classnames("wbkv9-PriceOption-rate", styles.rate)}>
      <div>
        {statusCode === "AVAILABLE" ? (
          <div>
            <div className={classnames("wbkv9-PriceOption-totalRate", styles.totalRate)}>
              {currency} <FormattedNumber value={rate} maximumFractionDigits={2} />{" "}
              {!selected && !selectedIsDisabled && (
                <span
                  className={classnames(
                    "wbkv9-PriceOption-dailyRateDifference",
                    styles.dailyRateDifference
                  )}>
                  (
                  {priceDifference > 0 ? (
                    <span>
                      &#9650;
                      {currency}{" "}
                    </span>
                  ) : (
                    <span>
                      &#9660;
                      {currency}{" "}
                    </span>
                  )}
                  <FormattedNumber value={Math.abs(priceDifference)} maximumFractionDigits={2} />)
                </span>
              )}
            </div>
            <div className={classnames("wbkv9-PriceOption-rateDifference", styles.rateDifference)}>
              <span>
                <FormattedNumber value={Math.abs(dailyRate)} maximumFractionDigits={2} />{" "}
              </span>
              <span>
                /<FormattedMessage {...msgs.perNight} />{" "}
              </span>
            </div>
          </div>
        ) : (
          <div>
            <div
              className={
                statusCode === "RESTRICTED"
                  ? classnames("wbkv9-PriceOption-restricted", styles.restricted)
                  : classnames(
                      "wbkv9-PriceOption-soldOut",
                      selected && "wbkv9-PriceOption-soldOut-selected",
                      styles.soldOut
                    )
              }>
              <BookableErrorMessage
                {...getStatusDetails(
                  statusCode,
                  statusFilterType,
                  statusValue,
                  styles.label,
                  styles.failed,
                  styles.passed
                )}
              />
            </div>
            <div
              className={classnames(
                "wbkv9-PriceOption-availabilityLink",
                selected && "wbkv9-PriceOption-availabilityLink-selected",
                styles.availabilityLink
              )}>
              <FormattedMessage {...msgs.viewAvailability} />
            </div>
          </div>
        )}
      </div>
    </div>
  </div>
);
function sortByGroupingCriteria(itemA, itemB, remainingBuckets) {
  const optionTextA = getOptionText(itemA, remainingBuckets, null, true);
  const optionTextB = getOptionText(itemB, remainingBuckets, null, true);
  if (optionTextA[0] > optionTextB[0]) {
    return 1;
  } else if (optionTextA[0] < optionTextB[0]) {
    return -1;
  } else {
    return 0;
  }
}
const renderModalContent = (
  inventoryGroup,
  criteria,
  inventoryGroups,
  selectedInventoryGroup,
  setInventoryGroups,
  closeModal,
  currency,
  numberOfNights,
  handleCloseModal
) => {
  if (!inventoryGroup) {
    return null;
  }
  // determines the order of the remaining buckets
  const defaultBucketOrder = [
    constants.BUCKETS.ACCOMMODATION,
    constants.BUCKETS.CONDITION,
    constants.BUCKETS.MEALPLAN,
    constants.BUCKETS.CONFIGURATION,
  ];
  const remainingBuckets = defaultBucketOrder.filter(
    bucket => bucket !== constants.BUCKETS.ACCOMMODATION && criteria.indexOf(bucket) === -1
  );
  const selectedInventory = inventoryGroup
    .get("inventories")
    .find(it => it.get("ticker") === inventoryGroup.get("selected"));
  const sortedInventoryGroup =
    inventoryGroup &&
    inventoryGroup.get("inventories") &&
    inventoryGroup.get("inventories").sort((itemA, itemB) => {
      if (itemA.get("totalRate") && !itemB.get("totalRate")) {
        return -1;
      } else if (!itemA.get("totalRate") && itemB.get("totalRate")) {
        return 1;
      } else if (itemA.get("totalRate") && itemB.get("totalRate")) {
        if (itemA.get("totalRate") > itemB.get("totalRate")) {
          return 1;
        } else if (itemA.get("totalRate") < itemB.get("totalRate")) {
          return -1;
        } else {
          return sortByGroupingCriteria(itemA, itemB, remainingBuckets);
        }
      } else {
        if (
          itemA.get("mealplan") &&
          itemA.get("mealplan").get("order") &&
          itemB.get("mealplan") &&
          itemB.get("mealplan").get("order")
        ) {
          if (itemA.get("mealplan").get("order") > itemB.get("mealplan").get("order")) {
            return 1;
          } else if (itemA.get("mealplan").get("order") < itemB.get("mealplan").get("order")) {
            return -1;
          }
        }
        return sortByGroupingCriteria(itemA, itemB, remainingBuckets);
      }
    });

  return (
    <div className={classnames("wbkv9-Popip-container", styles.popupContainer)}>
      <Popup
        closeWindow={handleCloseModal}
        headerText={<FormattedMessage {...msgs.listofRates} />}
        srcLogo={<RateIcon />}>
        <div>
          {sortedInventoryGroup
            .map(inventory => (
              <PriceOption
                key={inventory.get("ticker")}
                onOptionSelect={event =>
                  handleOptionSelect(
                    inventoryGroups,
                    selectedInventoryGroup,
                    inventory.get("ticker"),
                    setInventoryGroups,
                    closeModal
                  )
                }
                ticker={inventory.get("ticker")}
                currency={currency}
                text={getOptionText(inventory, remainingBuckets, null, true)}
                rate={inventory.get("totalRate")}
                statusCode={inventory.get("statusCode")}
                statusValue={inventory.get("statusValue")}
                statusFilterType={inventory.get("statusFilterType")}
                selectedIsDisabled={selectedInventory.get("statusCode") !== "AVAILABLE"}
                selected={inventory.get("ticker") === selectedInventory.get("ticker")}
                priceDifference={inventory.get("totalRate") - selectedInventory.get("totalRate")}
                dailyRate={inventory.get("totalRate") / numberOfNights}
              />
            ))
            .toArray()}
        </div>
      </Popup>
    </div>
  );
};
function GroupedInventoryList({
  criteria,
  inventoryGroups,
  currency,
  propertyTicker,
  handleModalContent,
  services,
  onRoomSelect,
  startDate,
  endDate,
  selectedInventoryGroup,
  setInventoryGroups,
  groupedInventories,
  maxBookableRooms,
  numberOfRoomsLeftLimit,
  numberOfNights,
  submitBookingForm,
  cancelRelease,
  handleScroll,
  handleCloseModal,
  roomDetailRepresentationType,
  showBookingOptionSummary,
  accommodationTicker,
  accommodationName,
  showDiscountsCalculation,
  fullWidth,
  inventoriesList,
  showCalendar,
  inventoryGroupingCriteria,
  cancellationRestrictions,
  getFirstNightCost,
  cancellationPoliciesInfo,
  inModification,
  isCartMaxItemsReached,
  loyalty,
  deviceType,
  userLoyaltyTier,
  depositRequiredTextConfiguration,
  depositNotRequiredTextConfiguration,
  linkToLoyaltyLogin,
  taxesText,
}) {
  const handleModal = (event, selectedGroup) => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    handleModalContent(
      renderModalContent(
        inventoryGroups.get(selectedGroup),
        criteria,
        inventoryGroups,
        selectedGroup,
        setInventoryGroups,
        handleCloseModal,
        currency,
        numberOfNights,
        handleCloseModal
      ),
      { className: "fullContent" }
    );
  };
  const remainingBuckets = Object.values(constants.BUCKETS).filter(
    bucket => bucket !== constants.BUCKETS.ACCOMMODATION && criteria.indexOf(bucket) === -1
  );

  const inventories =
    inventoriesList &&
    inventoriesList.map(el => {
      if (!el) {
        return null;
      }

      const [...keys] = inventoryGroups.keys();
      let inventoryGroup = null;
      let key = null;
      for (let i = 0; i < keys.length; i++) {
        const group = inventoryGroups.get(keys[i]);
        if (group.get("selected") === el.get("ticker")) {
          inventoryGroup = group;
          key = keys[i];
          break;
        }
      }
      const inventories = inventoryGroup && inventoryGroup.get("inventories");

      return (
        <Inventory
          key={el.get("ticker")}
          ticker={el.get("ticker")}
          mealplan={el.get("mealplan")}
          condition={el.get("condition")}
          rackRate={el.get("rackRate")}
          discountPercentage={el.get("discountPercentage")}
          discountAmount={el.get("discountAmount")}
          averageRate={el.get("averageRate")}
          totalRate={el.get("totalRate")}
          loyaltyRate={el.get("loyaltyRate")}
          availability={el.get("availability")}
          maxBookableRooms={Math.min(maxBookableRooms, el.get("availability"))}
          showAvailabilityAlert={el.get("availability") <= numberOfRoomsLeftLimit}
          statusCode={el.get("statusCode")}
          statusFilterType={el.get("statusFilterType")}
          statusValue={el.get("statusValue")}
          configuration={el.get("configuration")}
          roomDenomination={el.get("roomDenomination")}
          onRoomSelect={numberOfUnits => onRoomSelect({ inventory: el, numberOfUnits })}
          currency={currency}
          propertyTicker={propertyTicker}
          startDate={startDate}
          endDate={endDate}
          defaultPrimaryText={el.get("configuration").get("name")}
          primaryText={getOptionText(el, criteria.take(1))}
          secondaryText={criteria.size === 2 ? getOptionText(el, criteria.takeLast(1)) : undefined}
          dropDownText={getOptionText(el, remainingBuckets, "-")}
          onDropDownClick={event => handleModal(event, key)}
          mode={constants.INVENTORY_MODE.GROUPED}
          groupingCriteria={criteria}
          initiallyExpanded={
            el.get("statusCode") === constants.BOOKABLE_STATUS.AVAILABLE &&
            inventoryGroups.size <= 1
          }
          numberOfNights={numberOfNights}
          submitBookingForm={submitBookingForm}
          inventoryGroup={inventories}
          handleModalContent={handleModalContent}
          cancelRelease={cancelRelease}
          handleScroll={handleScroll}
          handleCloseModal={handleCloseModal}
          roomDetailRepresentationType={roomDetailRepresentationType}
          showBookingOptionSummary={showBookingOptionSummary}
          accommodationTicker={accommodationTicker}
          accommodationName={accommodationName}
          showDiscountsCalculation={showDiscountsCalculation}
          fullWidth={fullWidth}
          showCalendar={showCalendar}
          cancellationRestrictions={cancellationRestrictions}
          getFirstNightCost={getFirstNightCost}
          inventoryGroupingCriteria={inventoryGroupingCriteria}
          cancellationPoliciesInfo={cancellationPoliciesInfo}
          inModification={inModification}
          isCartMaxItemsReached={isCartMaxItemsReached}
          loyalty={loyalty}
          deviceType={deviceType}
          userLoyaltyTier={userLoyaltyTier}
          depositRequiredTextConfiguration={depositRequiredTextConfiguration}
          depositNotRequiredTextConfiguration={depositNotRequiredTextConfiguration}
          combined={el.getIn(["bookingOption", "combined"])}
          linkToLoyaltyLogin={linkToLoyaltyLogin}
          taxesText={taxesText}
        />
      );
    });

  return (
    <div className={classnames("wbkv9-GroupedInventoryList", styles.container)}>
      {inventories && Array.from(inventories.values())}
    </div>
  );
}

GroupedInventoryList.propTypes = {
  criteria: PropTypes.object,
  groupedInventories: PropTypes.object.isRequired,
};

GroupedInventoryList.defaultProps = {
  criteria: [constants.BUCKETS.CONFIGURATION, constants.BUCKETS.CONDITION],
};

function sortInventories(itemA, itemB, remainingBuckets) {
  const a = itemA.get("totalRate");
  const b = itemB.get("totalRate");
  const aStatus = itemA.get("statusCode");
  const bStatus = itemB.get("statusCode");
  if (a && !b) {
    return -1;
  } else if (!a && b) {
    return 1;
  } else if (a && b) {
    return a - b;
  } else if (
    aStatus === constants.PROPERTY_STATUS.RESTRICTED &&
    bStatus === constants.PROPERTY_STATUS.UNAVAILABLE
  ) {
    return -1;
  } else if (
    aStatus === constants.PROPERTY_STATUS.UNAVAILABLE &&
    bStatus === constants.PROPERTY_STATUS.RESTRICTED
  ) {
    return 1;
  } else {
    return sortByGroupingCriteria(itemA, itemB, remainingBuckets);
  }
}

function calculateInventoryGroupsOrder({ inventoryGroups, criteria }) {
  const remainingBuckets = Object.values(constants.BUCKETS).filter(
    bucket => bucket !== constants.BUCKETS.ACCOMMODATION && criteria.indexOf(bucket) === -1
  );
  return (
    inventoryGroups &&
    inventoryGroups
      .map((data, key) => {
        return data
          .get("inventories")
          .find(it => it.get("ticker") === data.get("selected"))
          .set("groupKey", key);
      })
      .sort((itemA, itemB) => {
        return sortInventories(itemA, itemB, remainingBuckets);
      })
      .map(it => it.get("groupKey"))
  );
}

const enhance = compose(
  pure,
  withState("selectedInventoryGroup", false),
  withState("inventoryGroups", "setInventoryGroups", props => props.groupedInventories),
  lifecycle({
    componentDidUpdate: function (prevProps) {
      if (
        this.props.currency !== prevProps.currency ||
        (this.props.groupedInventories &&
          prevProps.groupedInventories &&
          JSON.stringify(this.props.groupedInventories.toJS()) !==
            JSON.stringify(prevProps.groupedInventories.toJS()))
      ) {
        this.props.setInventoryGroups(() => this.props.groupedInventories);
      }
    },
  }),
  mapProps(props => {
    const inventoryGroupsOrder = calculateInventoryGroupsOrder({
      inventoryGroups: props.inventoryGroups,
      criteria: props.criteria,
    });
    const inventoriesList =
      inventoryGroupsOrder &&
      inventoryGroupsOrder.map(key => {
        const data = props.inventoryGroups.get(key);
        if (!data) {
          return null;
        }

        const inventories = data.get("inventories");
        return inventories.find(it => it.get("ticker") === data.get("selected"));
      });
    return {
      inventoriesList,
      ...props,
    };
  })
);
export default enhance(GroupedInventoryList);
